<template>
  <div id="app">
    <TheHeader :logged="loadHeader()" />

    <router-view />
  </div>
</template>

<script>
import TheHeader from '@/components/header/TheHeader';
import { get } from 'vuex-pathify';

import { USER_TOKEN_KEY } from '@/store/authModule';

export default {
  name: 'App',
  components: {
    TheHeader,
  },

  computed: {
    ...get('authModule', ['getLogin']),
  },

  mounted() {
    this.loadHeader();
  },

  methods: {
    loadHeader() {
      if (localStorage.getItem(USER_TOKEN_KEY) || this.getLogin()) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/_reset.scss';
@import '~@/assets/styles/app.scss';

#app {
  display: grid;
  grid-template-rows: auto 1fr;
  //gap: $spacing-xs;
  height: 100vh;
  font-family: $font-family-primary;
}
</style>
